import {isEqual} from 'lodash'

export default {
  methods: {
    routerPush ({name, params}) {
      const namesEqual = this.$route.name === name
      const paramsEqual = isEqual(this.$route.params, params)
      if (namesEqual && paramsEqual) return
      this.$router.push({name: name, params: params})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/routerPush.js